import { render, staticRenderFns } from "./BriefingDataSettings.vue?vue&type=template&id=fb23938c&scoped=true"
import script from "./BriefingDataSettings.vue?vue&type=script&lang=js"
export * from "./BriefingDataSettings.vue?vue&type=script&lang=js"
import style0 from "./BriefingDataSettings.vue?vue&type=style&index=0&id=fb23938c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb23938c",
  null
  
)

export default component.exports